import BillingAndUsage from "../components/billing-and-usage"; // Ensure this is the correct path to your component
import SvgIcons from "../../../shared/components/svgIcons";

const billingAndUsageRoute = [
  {
    path: "billing-and-usage",
    element: <BillingAndUsage />,
    link: "billing-and-usage",
    name: "Billing and Usage",
    permission: "Billing and Usage",
    icon: SvgIcons.BillingIcon, // Replace this with the appropriate icon reference
    index: 0,
  },
];
export default billingAndUsageRoute;
